import React from 'react';

import styled from 'styled-components';
import Modal from './Modal/modal';
import SmallModal from './Modal/small-modal';
import androidArrowBack from '../icons/android-arrow-back.svg';
import theme, { isThemeiOS } from '../themes';

import {
  BackArrow,
  Back,
  SmartViewNavbar,
  SmartButton,
  ValueWrapper,
  Value,
  Arrow,
  NavItem
} from './Common';

const ItemTitle = styled.div`
  margin-right: 5px;
  ${({actAsButton, disabled}) => (actAsButton && !disabled) && theme.SmartButtonLabel}
  ${({ disabled }) => disabled && theme.SmartButtonDisabled}
`;

export default class SmartView extends React.Component{
  static _type = 'SmartView';

  renderSmartView() {
    const {
      id,
      onToggleView,
      renderSmartView,
      small,
      showSmartView
    } = this.props;
    if (small && !isThemeiOS()) {
      return (
        <SmallModal
          id={`modal-${id}`}
          show={showSmartView}
          onToggleView={onToggleView}
        >
          {renderSmartView()}
        </SmallModal>
      );
    }
    return (
      <Modal id={`modal-${id}`} show={showSmartView}>
        {this.renderNavBar()}
        {renderSmartView()}
      </Modal>
    );
  }

  renderNavBar() {
    const {
      navBackLabel,
      navTitle,
      onToggleView
    } = this.props;
    return (
      <SmartViewNavbar>
        <NavItem left>
          <Back onClick={onToggleView}>
            {isThemeiOS() ?
              navBackLabel :
              <BackArrow
                className="back"
                dangerouslySetInnerHTML={{__html: androidArrowBack}}
              />
            }
          </Back>
        </NavItem>
        <NavItem center>
          {navTitle}
        </NavItem>
        <NavItem right />
      </SmartViewNavbar>
    );
  }

  renderBody() {
    const { label, disabled, value, onToggleView, actAsButton } = this.props;

    return (
      <SmartButton
        onClick={onToggleView}
        disabled={disabled}
      >
        <ItemTitle actAsButton={actAsButton} disabled={disabled}>
          {label}
        </ItemTitle>
        {!actAsButton && (
          <ValueWrapper>
            <Value>{value}</Value>
            {isThemeiOS() && <Arrow />}
          </ValueWrapper>
        )}
      </SmartButton>
    );
  }

  render() {
    return (
      <div>
        {this.renderBody()}
        {this.renderSmartView()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/smart-view.js